import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import SEO from "@/components/SEO";

function formatDate(iso) {
  try { return new Date(iso).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" }); }
  catch { return ""; }
}

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)); }, []);

  return (
    <div data-testid="blog-page" className="max-w-7xl mx-auto px-6 md:px-10 py-16">
      <SEO
        title="Blog — Journal & insights"
        description="Wholesale dessert insights, hospitality trends and Cake World stories for hotels, restaurants and cafés."
      />
      <div className="max-w-2xl">
        <div className="eyebrow">Journal</div>
        <h1 className="font-display text-5xl sm:text-6xl text-brand-ink mt-2 leading-none">Notes from the bakery.</h1>
        <p className="mt-6 text-brand-stone leading-relaxed">
          Ideas, wholesale playbooks and product news from the Cake World team.
        </p>
      </div>

      <div className="mt-12 grid md:grid-cols-2 gap-8">
        {posts.map((p) => (
          <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group bg-white rounded-3xl overflow-hidden border border-brand-line shadow-warm hover:shadow-warm-lg transition-shadow">
            <div className="aspect-[16/10] overflow-hidden">
              <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out" />
            </div>
            <div className="p-6">
              <div className="text-xs text-brand-stone">{formatDate(p.created_at)} · {p.author}</div>
              <h3 className="mt-2 font-display text-2xl text-brand-ink group-hover:text-brand-red transition-colors">{p.title}</h3>
              <p className="mt-3 text-sm text-brand-stone leading-relaxed line-clamp-3">{p.excerpt}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
